// Typed client for GET /api/tires/catalog — selectable Firestone tyre models
// for a Study-level tyre override (Slice 3). Each model is a catalog TYPE with
// per-corner median vertical stiffness; the backend only returns 4-corner types.
import { z } from "zod";

export const TireModelSchema = z.object({
  type: z.string(),
  k_vert_N_per_m: z.object({
    lf: z.number(), rf: z.number(), lr: z.number(), rr: z.number(),
  }),
});
export type TireModel = z.infer<typeof TireModelSchema>;

const TireCatalogSchema = z.object({ tire_models: z.array(TireModelSchema) });

export async function fetchTireCatalog(): Promise<TireModel[]> {
  const r = await fetch("/api/tires/catalog");
  if (!r.ok) throw new Error(`GET /api/tires/catalog failed: ${r.status}`);
  return TireCatalogSchema.parse(await r.json()).tire_models;
}
